module.exports = __webpack_public_path__ + "img/02.6d44bb01.png";